import { sortBy, uniqBy } from 'lodash';

import { isVisibleFirmPresentationTemplate } from '@/modules/presentationTemplates/presentationTemplate.utils';
import { sortSystemTemplates } from '@/modules/presentationTemplates/systemTemplateOrder.utils';

import { OnboardingPresentation_PresentationTemplateFragment } from './graphql/OnboardingPresentation.generated';

export type OnboardingPresentationTemplate =
  OnboardingPresentation_PresentationTemplateFragment;

interface TemplateQueryData {
  userTemplates: OnboardingPresentationTemplate[];
  tenantTemplates: OnboardingPresentationTemplate[];
  systemTemplates: OnboardingPresentationTemplate[];
}

export function getOrderedAvailableTemplates(
  { userTemplates, tenantTemplates, systemTemplates }: TemplateQueryData,
  tenantId: string
) {
  const orderedSystemTemplates = sortSystemTemplates(systemTemplates);
  const otherTemplates = sortBy(
    [...userTemplates, ...tenantTemplates].filter((template) =>
      isVisibleFirmPresentationTemplate(template, tenantId)
    ),
    (template) => template.displayName.toLocaleLowerCase()
  );
  return uniqBy([...orderedSystemTemplates, ...otherTemplates], 'id');
}
